// extracted by mini-css-extract-plugin
module.exports = {"bigHeader":"title_bigHeader__10h_z","right":"title_right__3C5aO"};